export { zettaClient } from '@/shared/logger/config';
